/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import AuthContainer from './AuthContainer.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import ProfilePassword from 'shared/ui/components/form-components/ProfilePassword.vue';

// Mixins
import errorHandler from 'auth/mixins/errorHandler';

const __vue_script__ = {
    name: 'ConfirmAccount',

    components: {
        AuthContainer,
        BaseInput,
        Checkbox,
        ProfilePassword
    },

    mixins: [errorHandler],

    props: {
        token: {
            type: String,
            default: ''
        },

        email: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            clauses: {},
            clausesLabel: {},
            errorMessage: null,
            name: null,
            newPassword: null,
            password: '',
            submitting: true,
            showNewTokenLink: false
        };
    },

    async created() {
        try {
            if (!this.email || !this.token) {
                this.handleError({ data: { reason: 'invalid token' } });
                return;
            }

            this.clauses = {};
            this.clausesLabel = {};

            for (const clause of this.$const.USER_MANDATORY_CLAUSES) {
                this.clauses[clause] = false;
                this.clausesLabel[clause] = this.$i18n.t(`clauses.${clause}`, this.$const.USER_MANDATORY_CLAUSES_I18N_REPLACEMENTS[clause]);
            }

            this.name = await this.$services.account.validateEmailAndToken(this.email, this.token);

            console.log('[ConfirmAccount] Email/Token validated:', this.name);
        } catch (error) {
            this.handleError(error);

        } finally {
            this.submitting = false;
        }
    },

    methods: {
        /**
         * Tries to activate the account
         */
        async activate() {
            try {
                this.reset();

                if (!await this.isPasswordStrongEnough()) {
                    return;
                }

                this.submitting = true;

                const { data } = await this.$services.account.validate({
                    name: this.name,
                    email: this.email,
                    password: this.password,
                    token: this.token,
                    accepted_clauses: this.clauses
                });

                console.info('[ConfirmAccount] Account activated', data);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('login.messages.account_activated').toString(),
                    type: 'success',
                    duration: 5000
                });

                this.$router.push(this.$const.ROUTE_LOGIN);

            } catch (error) {
                if (get(error, 'response.status') === 401) {
                    try {
                        await this.$services.account.requestNewValidation(this.email);
                    } catch (error) {
                        console.error('[ConfirmAccount] Could not request a new validation link', error);
                    }
                }

                this.handleError(error);

            } finally {
                this.submitting = false;
            }
        },

        /**
         * Perform a formal validation of the inserted fields
         *
         * @return {Promise<boolean>} whether the form is valid or not
         */
        async isPasswordStrongEnough() {
            const zxcvbn = await System.import(`${window.BSTG.extLibs}/zxcvbn.js`);
            const { score } = zxcvbn(this.password);

            if (score < 2) {
                this.errorMessage = 'login.messages.weak_password';
                return false;
            }

            return true;
        }
    },
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-container',[_c('validation-observer',{attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"confirm-account",on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.activate)}}},[_c('h2',[_vm._v(_vm._s(_vm.$t('login.forms.fieldsets.account_activation')))]),(_vm.errorMessage)?_c('div',{staticClass:"alert alert-error"},[_c('i18n',{attrs:{"path":_vm.errorMessage,"tag":"p"}},[(_vm.showNewTokenLink)?_c('router-link',{staticClass:"forgot-password",attrs:{"to":_vm.$const.ROUTE_SEND_RESET_TOKEN}},[_vm._v(_vm._s(_vm.$t('login.links.new_link')))]):_vm._e()],1)],1):_vm._e(),(!_vm.showNewTokenLink)?[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"name"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{staticClass:"name",attrs:{"placeholder":_vm.$t('login.forms.name'),"type":"text","name":"name","errors":errors,"autocomplete":"name"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})]}}],null,true)}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"email"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{staticClass:"email",attrs:{"placeholder":_vm.$t('login.forms.email'),"type":"email","name":"email","errors":errors,"disabled":"disabled","autocomplete":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})]}}],null,true)}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"newPassword"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('profile-password',{attrs:{"name":"newPassword","errors":errors},model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}})]}}],null,true)}),_c('validation-provider',{attrs:{"rules":"required|confirmed:newPassword","slim":true,"name":"password"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{staticClass:"password",attrs:{"placeholder":_vm.$t('login.forms.password_confirmation'),"type":"password","name":"password","errors":errors,"autocomplete":"new-password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})]}}],null,true)}),_vm._l((_vm.$const.USER_MANDATORY_CLAUSES),function(clause){return _c('validation-provider',{key:clause,attrs:{"rules":{ required: { allowFalse: false } },"slim":true,"name":clause},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('checkbox',{staticClass:"clause",attrs:{"label":_vm.clausesLabel[clause],"name":clause,"errors":errors},model:{value:(_vm.clauses[clause]),callback:function ($$v) {_vm.$set(_vm.clauses, clause, $$v)},expression:"clauses[clause]"}})]}}],null,true)})}),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"action"},[_c('button',{staticClass:"btn btn-login",attrs:{"disabled":_vm.submitting}},[_vm._v(_vm._s(_vm.$t('login.forms.actions.confirm_account')))])])])]:_vm._e(),_c('div',{staticClass:"actions links"},[_c('div',{staticClass:"action"},[_c('router-link',{staticClass:"forgot-password",attrs:{"to":_vm.$const.ROUTE_SEND_RESET_TOKEN}},[_vm._v(_vm._s(_vm.$t('login.links.request_new_token')))])],1),_c('div',{staticClass:"action"},[_c('router-link',{staticClass:"back-to-login",attrs:{"to":_vm.$const.ROUTE_LOGIN}},[_vm._v(_vm._s(_vm.$t('login.links.return_to_login')))])],1)])],2)]}}])})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ConfirmAccount.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__